export default __webpack_public_path__ + "static/media/kitap1.857b386c.jpg";